import React from "react"
import { NextSeo } from "next-seo"
import { useRouter } from "next/router"

import Layout from "~/components/Pages/Basic"
import {
  CATEGORIES_LABELS,
  getCategoryFromUrl,
} from "~/components/faq/constants"
import Center from "~/components/basic/Center"

import GeneralHeader from "./GeneralHeader"
import ArticleList from "./ArticleList"
import articles from "./articles"

const CategoryPage = () => {
  const router = useRouter()
  let list = articles
  let category
  if (router.query && router.query.category) {
    category = getCategoryFromUrl(router.query.category)
    if (category) {
      list = articles.filter((article) => article.type.includes(category))
    } else {
      list = []
    }
  }
  const notFound = list.length === 0 && router.query && router.query.category
  if (notFound && process.browser) {
    router.replace("/knowledge-base")
  }
  const categoryTitle = category ? CATEGORIES_LABELS[category] : undefined
  return (
    <>
      <NextSeo
        title={`${
          categoryTitle ? `${categoryTitle} ` : ""
        }Knowledge Base | WinIt`}
        description={`${
          categoryTitle ? `${categoryTitle} ` : ""
        }Knowledge Base | WinIt`}
        canonical="https://www.appwinit.com/knowledge-base"
        additionalMetaTags={[
          {
            property: "description",
            content: `${
              categoryTitle ? `${categoryTitle} ` : ""
            }Knowledge Base | WinIt`,
          },
        ]}
      />
      <Layout>
        <GeneralHeader />
        <ArticleList list={list} />
        {notFound && (
          <Center>
            <h2>We could not find that category...</h2>
          </Center>
        )}
      </Layout>
    </>
  )
}

export default CategoryPage
